module.exports = __webpack_public_path__ + "img/icono_luparosa.e6bc7645.svg";